export const getCountriesEndpoint = '/residence-core-ms/v1/geo/countries';

export const getAllCitiesEndpoint = '/residence-core-ms/v1/geo/allCities';
